import {
  ColorCollectionsDraftApi,
  useAPIQueryAndQueryKey,
} from "melco-shared-logic";
import { PublishState } from "../../../helper/publishedState";

export const queryKeyForColorCollection = (
  colorCollectionId: string,
  publishState: PublishState
) => ["colorCollection", colorCollectionId, publishState];

export const useColorCollection = (
  colorCollectionId: string,
  publishState: PublishState
) => {
  return useAPIQueryAndQueryKey(
    ColorCollectionsDraftApi,
    queryKeyForColorCollection(colorCollectionId, publishState),
    async (api) =>
      api.userColorCollectionsGetDef({ id: colorCollectionId, publishState })
  );
};
